import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { adobeAnalytics } from 'adobe-analytics';
import { DealerLocation, portalApplicationId } from 'graphql-client';
import { takeUntil } from 'rxjs';

import { AWSService } from '../services/aws.service';
import { ScrollingService } from '../services/scrolling.service';
import { Unsubscribe } from '../shared/classes/unsubscribe.class';

@Component({
  selector: 'capq-final-success-response',
  templateUrl: './final-success-response.component.html',
  styleUrls: ['./final-success-response.component.scss'],
})
export class FinalSuccessResponseComponent
  extends Unsubscribe
  implements OnInit, AfterViewInit
{
  congratsImg = 'assets/images/congrats.png';
  formFieldData: any;
  logoURL = './assets/images/CA_Logo.svg';
  closeURL = './assets/images/icn_close.png';
  @Input() adobeScriptLoaded = false;
  @Input() prequalified = false;
  @Input() dealers: DealerLocation[] = [];

  @ViewChild('topElement') topElement!: ElementRef<HTMLDivElement>;

  constructor(
    private readonly awsService: AWSService,
    private readonly scrollService: ScrollingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.awsService.prequalifiedJSONData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (data) {
          this.formFieldData = data.finalSuccess;
        }
      });

    this.adobeScriptLoaded &&
      adobeAnalytics.emitEvent('cac-page-view', null, {
        form_design: 'v 1.0',
        section_name: 'dealers connect',
        form_submission_id: (portalApplicationId() || '').toString(),
        dealer_list: '',
        form_submission_status: 'success',
        form_failure_reason: undefined,
        event_type: 'cac-page-view',
      });
  }

  ngAfterViewInit(): void {
    this.scrollService.scrollToTop(this.topElement.nativeElement);
  }

  navigateToHome() {
    document.location.href = document.location.origin;
  }
}
